<script>
import Modal from '@/components/atoms/Modal'
import InputLine from '@/components/atoms/inputlib/components/InputLine'
import FormValidation from '@/components/atoms/FormValidation.vue'
import ButtonLoader from '@/components/atoms/ButtonLoader'

export default {
    name: 'ModalVatPrompt',
    components: { Modal, InputLine, FormValidation, ButtonLoader },
    data() {
        return {
            isOpen: false,
            showForm: false,
            formValid: false,
        }
    },
    computed: {
        cart() {
            return this.$cart
        },
    },
    methods: {
        open() {
            this.isOpen = true
            this.showForm = false
            this.formValid = false
        },
        close() {
            this.isOpen = false
        },
        selectNo() {
            this.$cart.setInvoice()
            this.close()
            this.$emit('no')
        },
        showInvoiceForm() {
            this.$cart.setInvoice(this.$user.model)
            this.showForm = true
        },
        goBack() {
            this.$cart.setInvoice()
            this.showForm = false
            this.formValid = false
        },
        confirmWithInvoice() {
            if (!this.formValid) return
            this.close()
            this.$emit('yes')
        },
        onFormValid(isValid) {
            this.formValid = isValid
        },
    },
}
</script>

<template lang="pug">
.modal-vat-prompt
    modal(ref="Modal" v-model="isOpen" :closable="false")
        template(v-slot:header)
            h1.m-auto {{ $t('cart.vat_prompt.title') }}
        template(v-if="showForm" v-slot:body)
            form-validation(@valid="onFormValid")
                input-line.pt-5(
                    v-model="$cart.model.billing_name"
                    :readonly="cart.loading"
                    validate="billingName"
                    :placeholder="$t('labels.placeholder.billing_name')"
                    :max="255"
                    live required) {{ $t('details.name') }}
                input-line.pt-5(
                    v-model="$cart.model.billing_vatnumber"
                    :disabled="cart.loading"
                    validate="billingVatnumber"
                    regex="^[0-9]{8}-[0-9]{1}-[0-9]{2}$"
                    :placeholder="$t('labels.placeholder.billing_vatnumber')"
                    :max="255"
                    live required) {{ $t('details.vat') }}
                input-line(
                    v-model="$cart.model.billing_full_address"
                    :readonly="cart.loading"
                    validate="billingFullAddress"
                    :placeholder="$t('labels.placeholder.billing_full_address')"
                    :max="255"
                    live required) {{ $t('details.address') }}
                input-line(
                    v-model="$cart.model.billing_sub_address"
                    :readonly="cart.loading"
                    validate="billingSubAddress"
                    :placeholder="$t('labels.placeholder.billing_sub_address')"
                    :max="255"
                    live)
        template(v-slot:footer)
            template(v-if="!showForm")
                button.btn.btn-secondary(@click="selectNo") {{ $t('cart.vat_prompt.no') }}
                button.btn.btn-primary(@click="showInvoiceForm") {{ $t('cart.vat_prompt.yes') }}
            template(v-else)
                button.btn.btn-secondary(@click="goBack") {{ $t('cart.vat_prompt.back') }}
                button-loader.btn.btn-primary(
                    @click="confirmWithInvoice"
                    :class="{'disabled': !formValid}"
                    inline) {{ $t('cart.place_order') }}
</template>
